import React from 'react'
import SettingModal from '../layout/SettingModal';
export const AddButton = () => {
    return (
        <SettingModal></SettingModal>
    )
}